// extracted by mini-css-extract-plugin
export default {"root":"_28ooy","large":"_2C7D9","hoverable":"_3nY0x","medium":"c4Tk1","small":"_1_d3y"};